import React, { memo } from "react";
import { compose } from "redux";
import { reduxForm } from "redux-form";

// import { connect } from "react-redux";
import { connect, useSelector, useDispatch } from "react-redux";
import { createStructuredSelector } from "reselect";

import validate from "validations";
import { forms, paths } from "utils/constants";
import SmartRender from "containers/SmartRender";

import {
  makeSelectPageValidations,
  makeSelectCisHrForm,
  makeSelectCisFormHrInitialValues,
  makeSelectCisFormHrParams
} from "ducks/selectors";
import Spinner, { styles } from "components/Spinner";
import { uploadCisHRForm } from "ducks/actions";
import { gotoUrl, pathWithChannel } from "utils/helpers";

const CisRequestHR = Component =>
  function Comp(props) {
    const loading = false;
    const dispatch = useDispatch();
    const requestPayload = useSelector(makeSelectCisFormHrParams());
    const onSubmit = () => {
      dispatch(
        uploadCisHRForm(requestPayload, (result, errors) => {
          if (!errors) {
            gotoUrl(pathWithChannel(paths.CIS_REQUEST_HR_SUCCESS));
          }
        })
      );
    };

    if (loading) {
      return <Spinner size={200} sx={styles.fullPage} />;
    }
    return <Component {...props} onSubmit={onSubmit} />;
  };

const mapStateToProps = createStructuredSelector({
  formValidations: makeSelectPageValidations(forms.CIS_REQUEST_HR_FORM),
  formValues: makeSelectCisHrForm(),
  payload: makeSelectCisFormHrParams(),
  initialValues: makeSelectCisFormHrInitialValues()
});

const mapDispatchToProps = {};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
  withConnect,
  reduxForm({
    form: forms.CIS_REQUEST_HR_FORM,
    destroyOnUnmount: false,
    validate
  }),
  memo
)(CisRequestHR(SmartRender));
